import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthContext";
import { useStateContext } from "../../../contexts/ContextProvider";
import { postRequest } from "../../../constants/api";
import { ShowTablePenetapanPemenang } from "../../../components/ShowTable";
import { FetchErrorHandling } from "../../../components/FetchErrorHandling";
import { SearchBar, Loader, ButtonModifier } from "../../../components";
import { formatDate } from "../../../constants/helper";
import { Container, Form, Row, Col } from "react-bootstrap";
import { Box, Pagination, Button, ButtonGroup } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import SearchIcon from "@mui/icons-material/Search";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useDownloadExcel } from "react-export-table-to-excel";
import DownloadIcon from "@mui/icons-material/Download";
import PrintIcon from "@mui/icons-material/Print";
import useScreenWidth from "../../../hooks/useScreenWidth";

const TampilPenetapanPemenang = () => {
  const screenSize = useScreenWidth();
  const tableRef = useRef(null);
  const reportTemplateRef = useRef(null);
  const { user, dispatch, setting } = useContext(AuthContext);
  const location = useLocation();
  const id = location.pathname.split("/")[2];

  const [isFetchError, setIsFetchError] = useState(false);

  // Angsuran
  const [lelangBulananId, setLelangBulananId] = useState("");
  const [kelompokId, setKelompokId] = useState("");
  const [angsuranKelompokId, setAngsuranKelompokId] = useState("");
  const [pesertaKelompokId, setPesertaKelompokId] = useState("");
  const [namaPeserta, setNamaPeserta] = useState("");
  const [noKelompok, setNoKelompok] = useState("");
  const [no, setNo] = useState("");
  const [tglJatuhTempo, setTglJatuhTempo] = useState("");
  const [tglPenetapanPemenang, setTglPenetapanPemenang] = useState("");
  const [nominal, setNominal] = useState("");

  // Jaminan Peserta
  const [jenisJaminan, setJenisJaminan] = useState("");
  const [nomorJaminan, setNomorJaminan] = useState("");
  const [nilaiJaminan, setNilaiJaminan] = useState("");

  const [penetapanPemenangs, setPenetapanPemenangs] = useState([]);

  const [penetapanPemenangReport, setPenetapanPemenangReport] = useState([]);
  const [previewPdf, setPreviewPdf] = useState(false);
  const [previewExcel, setPreviewExcel] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  let [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [query, setQuery] = useState("");

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setSearchTerm(query);
  };

  useEffect(() => {
    getPenetapanPemenangById();
  }, [id]);

  useEffect(() => {
    getPenetapanPemenangs();
  }, [page, searchTerm]);

  const getPenetapanPemenangs = async () => {
    setLoading(true);
    try {
      const response = await postRequest(
        `/penetapanPemenangsPagination?search_query=${searchTerm}&page=${page}&limit=${limit}`,
        {},
        navigate,
        dispatch,
      );
      setQuery(searchTerm);
      setPenetapanPemenangs(response.data.penetapanPemenangs);
      setPage(response.data.page);
      setPages(response.data.totalPage);
      setRows(response.data.totalRows);
    } catch (error) {
      setIsFetchError(true);
    }
    setLoading(false);
  };

  const getPenetapanPemenangReportData = async () => {
    try {
      const response = await postRequest(
        `/penetapanPemenangs`,
        {},
        navigate,
        dispatch,
      );
      setPenetapanPemenangReport(response.data);
    } catch (error) {
      setIsFetchError(true);
    }
  };

  const getPenetapanPemenangById = async () => {
    setLoading(true);
    if (id) {
      const response = await postRequest(
        `/penetapanPemenangs/${id}`,
        {},
        navigate,
        dispatch,
      );

      // Angsuran
      setLelangBulananId(response.data.lelangbulanan.id);
      setKelompokId(response.data.lelangbulanan.angsurankelompok.kelompok.id);
      setAngsuranKelompokId(response.data.lelangbulanan.angsurankelompok.id);
      setPesertaKelompokId(response.data.pesertakelompok.id);
      setNamaPeserta(response.data.pesertakelompok.peserta.namaPeserta);
      setNoKelompok(
        response.data.lelangbulanan.angsurankelompok.kelompok.noKelompok,
      );
      setNo(response.data.lelangbulanan.angsurankelompok.no);
      setTglJatuhTempo(
        new Date(response.data.lelangbulanan.angsurankelompok.tglJatuhTempo),
      );
      setTglPenetapanPemenang(new Date(response.data.tglPenetapanPemenang));
      setNominal(response.data.nominal);

      // Jaminan Peserta
      setJenisJaminan(response.data.pesertakelompok.jenisJaminan);
      setNomorJaminan(response.data.pesertakelompok.nomorJaminan);
      setNilaiJaminan(response.data.pesertakelompok.nilaiJaminan);
    }
    setLoading(false);
  };

  const deletePenetapanPemenang = async (id) => {
    setLoading(true);
    try {
      await postRequest(
        `/deletePenetapanPemenang/${id}`,
        {
          lelangBulananId,
          kelompokId,
          angsuranKelompokId,
          pesertaKelompokId,
          nominal,

          // Jaminan Peserta
          jenisJaminan,
          nomorJaminan,
          nilaiJaminan,
        },
        navigate,
        dispatch,
      );
      getPenetapanPemenangs();

      // Angsuran
      setAngsuranKelompokId("");
      setNoKelompok("");
      setNo("");
      setTglJatuhTempo("");
      setTglPenetapanPemenang("");
      setNominal("");

      // Jaminan Peserta
      setJenisJaminan("");
      setNomorJaminan("");
      setNilaiJaminan("");

      navigate("/penetapanPemenang");
    } catch (error) {
      if (error.response.data.message.includes("foreign key")) {
        alert(`${no} tidak bisa dihapus!`);
      }
    }
    setLoading(false);
  };

  const downloadPdf = () => {
    var date = new Date();
    var current_date =
      date.getDate().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      "-" +
      (date.getMonth() + 1).toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      "-" +
      date.getFullYear();
    var current_time =
      date.getHours().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      ":" +
      date.getMinutes().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      ":" +
      date.getSeconds().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
    const doc = new jsPDF();
    doc.setFontSize(12);
    doc.text(`${setting.namaPerusahaan} - ${setting.kotaPerusahaan}`, 15, 10);
    doc.text(`${setting.alamatPerusahaan}`, 15, 15);
    doc.setFontSize(16);
    doc.text(`Daftar Penetapan Pemenang`, 85, 30);
    doc.setFontSize(10);
    doc.text(
      `Dicetak Oleh: ${user.username} | Tanggal : ${current_date} | Jam : ${current_time}`,
      15,
      290,
    );
    doc.autoTable({
      html: "#table",
      startY: doc.pageCount > 1 ? doc.autoTableEndPosY() + 20 : 45,
      headStyles: {
        fillColor: [117, 117, 117],
        color: [0, 0, 0],
      },
    });
    window.open(URL.createObjectURL(doc.output("blob")));
  };

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Penetapan Pemenang",
    sheet: "PenetapanPemenang",
  });

  const handleGeneratePdf = () => {
    const doc = new jsPDF({
      format: "a4",
      unit: "px",
    });
    doc.html(reportTemplateRef.current, {
      async callback(doc) {
        await window.open(URL.createObjectURL(doc.output("blob")));
      },
      html2canvas: { scale: 0.44 },
    });
  };

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  if (loading) {
    return <Loader />;
  }

  if (isFetchError) {
    return <FetchErrorHandling />;
  }

  return (
    <Container>
      {id && (
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => {
            navigate("/penetapanPemenang");
          }}
          sx={{ marginRight: 2 }}
        >
          {"< Kembali"}
        </Button>
      )}
      <h3>Lelang</h3>
      <h5 style={{ fontWeight: 400 }}>Daftar Penetapan Pemenang</h5>
      {/* <Box sx={downloadButtons}>
        <ButtonGroup variant="outlined" color="secondary">
          <Button
            color="primary"
            startIcon={<SearchIcon />}
            onClick={() => {
              setPreviewPdf(!previewPdf);
              getPenetapanPemenangReportData();
              setPreviewExcel(false);
            }}
          >
            PDF
          </Button>
          <Button
            color="secondary"
            startIcon={<SearchIcon />}
            onClick={() => {
              setPreviewExcel(!previewExcel);
              getPenetapanPemenangReportData();
              setPreviewPdf(false);
            }}
          >
            Excel
          </Button>
        </ButtonGroup>
      </Box> */}
      {previewPdf && (
        <div>
          <Button
            variant="outlined"
            startIcon={<PrintIcon />}
            onClick={() => downloadPdf()}
          >
            CETAK
          </Button>
          <table class="table" id="table">
            <thead>
              <tr>
                <th>No</th>
                <th>Tgl. Jatuh Tempo</th>
                <th>Nominal</th>
              </tr>
            </thead>
            <tbody>
              {penetapanPemenangReport.map((penerimaan, index) => {
                return (
                  <tr key={penerimaan.id}>
                    <td>{index + 1}</td>
                    <td>
                      {formatDate(penerimaan.angsurankelompok.tglJatuhTempo)}
                    </td>
                    <td>{penerimaan.nominal.toLocaleString("en-US")}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
      <div>
        {previewExcel && (
          <Button
            variant="outlined"
            startIcon={<DownloadIcon />}
            onClick={onDownload}
          >
            EXCEL
          </Button>
        )}
        <table ref={tableRef}>
          {previewExcel && (
            <tbody>
              <tr>
                <th>No</th>
                <th>Tgl. Jatuh Tempo</th>
                <th>Nominal</th>
              </tr>
              {penetapanPemenangReport.map((penerimaan, index) => {
                return (
                  <tr key={penerimaan.id}>
                    <td>{index + 1}</td>
                    <td>
                      {formatDate(penerimaan.angsurankelompok.tglJatuhTempo)}
                    </td>
                    <td>{penerimaan.nominal.toLocaleString("en-US")}</td>
                  </tr>
                );
              })}
            </tbody>
          )}
        </table>
      </div>
      {!id && (
        <Box sx={buttonModifierContainer}>
          <ButtonGroup variant="contained">
            <Button
              color="success"
              sx={{ bgcolor: "success.light", textTransform: "none" }}
              startIcon={<AddCircleOutlineIcon />}
              size="small"
              onClick={() => {
                navigate(`/penetapanPemenang/tambahPenetapanPemenang`);
              }}
            >
              Tambah
            </Button>
          </ButtonGroup>
        </Box>
      )}
      <Box sx={buttonModifierContainer}>
        <ButtonModifier
          id={id}
          kode={id}
          editLink={`/penetapanPemenang/${id}/edit`}
          deleteUser={deletePenetapanPemenang}
          nameUser={no}
        />
      </Box>
      {id && (
        <Container>
          <hr />
          <Form>
            <Box sx={showDataContainer}>
              <Box sx={showDataWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="6" style={textRight}>
                        No. Kelompok :
                      </Form.Label>
                      <Col sm="6">
                        <Form.Control disabled value={noKelompok} />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="6" style={textRight}>
                        No. Angsuran :
                      </Form.Label>
                      <Col sm="6">
                        <Form.Control disabled value={no} />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="6" style={textRight}>
                        Tgl. Jatuh Tempo :
                      </Form.Label>
                      <Col sm="6">
                        <Form.Control
                          value={formatDate(tglJatuhTempo)}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="6" style={textRight}>
                        Peserta :
                      </Form.Label>
                      <Col sm="6">
                        <Form.Control value={namaPeserta} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="6" style={textRight}>
                        Tgl. Penetapan Pemenang :
                      </Form.Label>
                      <Col sm="6">
                        <Form.Control
                          value={formatDate(tglPenetapanPemenang)}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="6" style={textRight}>
                        Nominal :
                      </Form.Label>
                      <Col sm="6">
                        <Form.Control
                          value={nominal.toLocaleString("en-US")}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[showDataWrapper, secondWrapper]}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="6" style={textRight}>
                        Jenis Jaminan :
                      </Form.Label>
                      <Col sm="6">
                        <Form.Control value={jenisJaminan} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="6" style={textRight}>
                        Nomor Jaminan :
                      </Form.Label>
                      <Col sm="6">
                        <Form.Control value={nomorJaminan} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="6" style={textRight}>
                        Nilai Jaminan :
                      </Form.Label>
                      <Col sm="6">
                        <Form.Control
                          value={nilaiJaminan.toLocaleString("en-US")}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
            </Box>
          </Form>
        </Container>
      )}
      <hr />
      {!id && (
        <>
          <Form onSubmit={searchData}>
            <Box sx={searchBarContainer}>
              <SearchBar value={query} setSearchTerm={setQuery} />
              <Button
                variant="contained"
                type="submit"
                color="primary"
                disableElevation
              >
                Cari
              </Button>
            </Box>
          </Form>
          <Box sx={tableContainer}>
            <ShowTablePenetapanPemenang currentPosts={penetapanPemenangs} />
          </Box>
          <Box sx={tableContainer}>
            <Pagination
              count={pages}
              page={page + 1}
              onChange={handleChange}
              color="primary"
              size={screenSize <= 600 ? "small" : "large"}
            />
          </Box>
        </>
      )}
    </Container>
  );
};

export default TampilPenetapanPemenang;

const buttonModifierContainer = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const downloadButtons = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const pdfContainer = {
  padding: "20px",
  letterSpacing: "0.01px",
  fontSize: "12px",
  fontFamily: "sans-serif",
  width: "1000px",
};

const titleCetak = {
  textAlign: "center",
  fontWeight: "bold",
  marginTop: "20px",
};

const noTandaTerimaCetak = {
  textAlign: "center",
  fontWeight: "500",
};

const containerContent = {
  display: "flex",
  marginLeft: "120px",
};

const containerContentRight = {
  display: "flex",
  marginLeft: "460px",
  marginTop: "-20px",
};

const wrapperContent = {
  marginTop: "20px",
  width: "800px",
  fontSize: "15px",
};

const numberContent = {
  marginLeft: "20px",
  width: "100px",
  display: "flex",
  justifyContent: "right",
};

const thirdNumberContent = {
  display: "flex",
  marginLeft: "20px",
  marginTop: "-15px",
};

const totalContainer = {
  display: "flex",
  marginLeft: "20px",
  marginTop: "-15px",
};

const totalText = {
  marginLeft: "110px",
  marginRight: "46px",
  fontWeight: "bold",
};

const totalWrapper = {
  display: "flex",
  height: "20px",
  borderBottom: "1px solid black",
};

const totalNumber = {
  marginLeft: "20px",
  width: "100px",
  display: "flex",
  justifyContent: "right",
};

const showDataContainer = {
  mt: 4,
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const showDataWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};
